import { createSlice } from "@reduxjs/toolkit";
import { buildPublicUrl } from "../utils/imageUrl";

const initialState = { objectPath: null, publicUrl: null };

const profileImageSlice = createSlice({
  name: "profileImage",
  initialState,
  reducers: {
    setProfileImagePath(state, action) {
      state.objectPath = action.payload || null;
      state.publicUrl = buildPublicUrl(state.objectPath);
    },
    resetProfileImage(state) {
      state.objectPath = null;
      state.publicUrl = null;
    },
  },
});

export const { setProfileImagePath, resetProfileImage } = profileImageSlice.actions;
export const selectProfileImageUrl = (s) => s.profileImage.publicUrl;
export const selectProfileImagePath = (s) => s.profileImage.objectPath;
export default profileImageSlice.reducer;
